module.exports = __webpack_public_path__ + "static/media/round_2.53401f1b.png";